import axios from 'axios';
import logger from './logService';
// import { toast } from "react-toastify";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// axios.defaults.withCredentials = true;

axios.interceptors.response.use(null, error => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    logger.log(error.response);

    // toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

function setCSRF(token) {
  axios.defaults.headers.common['X-CSRF-Token'] = token;
}

function setJwt(jwt) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwt;
  //
  // axios.defaults.headers.common['x-auth-token'] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  setCSRF,
};
